// pages/startups.js
import {
  Box,
  Grid,
  Image,
  Text,
  VStack,
  Heading,
  Container,
  Link,
} from '@chakra-ui/react';
import React from 'react';

const innovatorsSpotlight = [
  {
    name: 'Climes',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at15708PM-8eRW0Nv9uCaV.png',
    website: 'https://climes.io/',
  },
  {
    name: 'Planet Electric',
    logo: 'https://static.levocdn.com/WGLBUT82/94791135bc139cf518470794025fa085c0f3c8mv2-rSCClHyXsq6S.jpg',
    website: 'https://www.planetelectric.in/',
  },
  {
    name: 'SuperHumanRace',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at24116PM-uY2nYme0yhfL.png',
    website: 'https://mysuperhumanrace.com/',
  },
  {
    name: 'Farm Theory',
    logo: 'https://static.levocdn.com/WGLBUT82/headerLogo35b1806d-KQ5qQq3Vo1VP.png',
    website: 'http://farmtheory.in/',
  },
  {
    name: 'Wastelink',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at24908PM-6HgtxP0SBvrz.png',
    website: 'https://wastelink.co/',
  },
  {
    name: 'Smart Joules',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at30718PM-uY2VYme0kiWk.png',
    website: 'https://smartjoules.co.in/',
  },
  {
    name: 'Stepchange',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at33045PM-sR8GjbX2Bqr2.png',
    website: 'https://www.stepchange.earth/',
  },
  {
    name: 'GoSharpener',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at20030PM-vxmWzQUGa2Ar.png',
    website: 'https://gosharpener.com/',
  },
  {
    name: 'Irasus Technologies',
    logo: 'https://static.levocdn.com/WGLBUT82/cropped-iRasus-Logo-30Wqpj9Suo6a.png',
    website: 'https://irasus.com/',
  },
  {
    name: 'Terrabioware',
    logo: 'https://static.levocdn.com/WGLBUT82/Group403-uY2iYme0ssBz.png',
    website: 'https://www.terrabioware.co/',
  },
  {
    name: 'Nutrifresh',
    logo: 'https://static.levocdn.com/WGLBUT82/Newlogo-k5KvTHF8p520.png',
    website: 'https://nutrifresh.co.in/',
  },
  {
    name: 'Numen Ventures',
    logo: 'https://static.levocdn.com/WGLBUT82/image-66-Photoroom-1-qW3Y1Upn2ARS.webp',
    website: 'https://numenventures.in/',
  },
  {
    name: 'ENLOG',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at15858PM-ZnMIUQpjTupJ.png',
    website: 'https://enlog.co.in/',
  },
  {
    name: 'We Craft Studio',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at30806PM-T71Sn3hAV9ta.png',
    website: 'https://wecraftstudio.com/',
  },
  {
    name: 'Eeki Foods',
    logo: 'https://static.levocdn.com/WGLBUT82/eeki-foods-YhEVTNmBcB0n.png',
    website: 'https://www.eeki.com/',
  },
  {
    name: 'Kazam',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at30324PM-JtaZEthF9UvS.png',
    website: 'https://www.kazam.in/',
  },
];

const greenPopupVillage = [
  {
    name: 'Bhagirath Laboratories',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at15320PM-pKkeluUcJra7.png',
    website: 'https://www.bhagirathlabs.com/',
  },
  {
    name: 'BrightBlu',
    logo: 'https://static.levocdn.com/WGLBUT82/bright-blue-logo-30WWpj9SQTvh.png',
    website: 'https://www.brightblu.com/',
  },
  {
    name: 'ClearMeat',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at15515PM-iPDuf0hDfSLq.png',
    website: 'https://www.clearmeat.org/',
  },
  {
    name: 'Climes',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at15708PM-8eRW0Nv9uCaV.png',
    website: 'https://climes.io/',
  },
  {
    name: 'EcoReco',
    logo: 'https://static.levocdn.com/WGLBUT82/logo-gVHHJ6IQS0OA.png',
    website: 'https://ecoreco.com/',
  },
  {
    name: 'ENLOG',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at15858PM-ZnMIUQpjTupJ.png',
    website: 'https://enlog.co.in/',
  },
  {
    name: 'Watsan Envirotech',
    logo: 'https://static.levocdn.com/WGLBUT82/watsan-logo-1-n3qoflIcbmdU.webp',
    website: 'https://watsan.in/',
  },
  {
    name: 'GoSharpener',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at20030PM-vxmWzQUGa2Ar.png',
    website: 'https://gosharpener.com/',
  },
  {
    name: 'Hitesh Enviro Engineers',
    logo: 'https://static.levocdn.com/WGLBUT82/HEEPLlogorevised-removebg-preview-9GFtqRsPzQaR.webp',
    website: 'https://www.hee-pl.com/',
  },
  {
    name: 'Nutrifresh',
    logo: 'https://static.levocdn.com/WGLBUT82/Newlogo-k5KvTHF8p520.png',
    website: 'https://nutrifresh.co.in/',
  },
  {
    name: 'Numen Ventures',
    logo: 'https://static.levocdn.com/WGLBUT82/image-66-Photoroom-1-qW3Y1Upn2ARS.webp',
    website: 'https://numenventures.in/',
  },
  {
    name: 'Planet Electric',
    logo: 'https://static.levocdn.com/WGLBUT82/94791135bc139cf518470794025fa085c0f3c8mv2-rSCClHyXsq6S.jpg',
    website: 'https://www.planetelectric.in/',
  },
  {
    name: 'Reput.ai',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at23651PM-moxO3bBnPvSw.png',
    website: 'https://www.reput.ai/#/home',
  },
  {
    name: 'Revfin',
    logo: 'https://static.levocdn.com/WGLBUT82/logo-GLUIccLQe5gc.jpg',
    website: 'https://www.revfin.in/',
  },
  {
    name: 'Stepchange',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at33045PM-sR8GjbX2Bqr2.png',
    website: 'https://www.stepchange.earth/',
  },
  {
    name: 'SuperHumanRace',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at24116PM-uY2nYme0yhfL.png',
    website: 'https://mysuperhumanrace.com/',
  },
  {
    name: 'Wastelink',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at24908PM-6HgtxP0SBvrz.png',
    website: 'https://wastelink.co/',
  },
  {
    name: 'Vida by Hero MotoCorp',
    logo: 'https://static.levocdn.com/WGLBUT82/Vida-Logo--PBH---CTC02-oilwrVbY4fO4.png',
    website: 'https://www.vidaworld.com/',
  },
  {
    name: 'Stride Green',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-27at52032PM-removebg-preview-4JOOlpgDUAYK.png',
    website: 'https://stridegreen.in/',
  },
  {
    name: 'Blue Planet',
    logo: 'https://static.levocdn.com/WGLBUT82/17169847282ec16ed9a433f58b9a30-5AQsZx6dxXSh.png',
    website: 'https://www.blueplanet.asia/',
  },
  {
    name: 'Ecofy',
    logo: 'https://static.levocdn.com/WGLBUT82/logo-ecofy-sticky-VbX5m3aF3PaY.png',
    website: 'https://www.ecofy.co.in/',
  },
  {
    name: 'EcoSoul Home',
    logo: 'https://static.levocdn.com/WGLBUT82/LogoWhite-eg6BlkhEkKSO.svg',
    website: 'https://ecosoulhome.in/',
  },
  {
    name: 'Eeki Foods',
    logo: 'https://static.levocdn.com/WGLBUT82/eeki-foods-YhEVTNmBcB0n.png',
    website: 'https://www.eeki.com/',
  },
  {
    name: 'Project - Lithium',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at25659PM-pKkdluUctKuO.png',
    website: 'https://project-lithium.com/',
  },
  {
    name: 'Solinas Integrity',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at25641PM-qW3s1Upnj0U4.png',
    website: 'https://www.solinas.in/',
  },
  {
    name: 'S4S Technologies',
    logo: 'https://static.levocdn.com/WGLBUT82/logo-1-WT0NrjvO8drW.jpeg',
    website: 'https://s4stechnologies.com/',
  },
  {
    name: 'GrowBillionTrees',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at30654PM-LkpyHyUuTrCc.png',
    website: 'https://growbilliontrees.com/',
  },
  {
    name: 'Bare Craft Consulting',
    logo: 'https://space.levo.in.net/WGLBUT82/Screenshot2025-01-13at60417PM-aytrN6VkgBTQ.png',
    website: 'https://barecraft.my.canva.site/barecraft',
  },
  {
    name: 'Chupps',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at30506PM-jfwep7MzntEX.png',
    website: 'https://www.chupps.com/',
  },
  {
    name: 'ENEN Green',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at30524PM-8eRb0Nv9WhZ3.png',
    website: 'https://www.enengreen.com/',
  },
  {
    name: 'Kazam',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at30324PM-JtaZEthF9UvS.png',
    website: 'https://www.kazam.in/',
  },
  {
    name: 'Smart Joules',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at30718PM-uY2VYme0kiWk.png',
    website: 'https://smartjoules.co.in/',
  },
  {
    name: 'We Craft Studio',
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-09at30806PM-T71Sn3hAV9ta.png',
    website: 'https://wecraftstudio.com/',
  },
];

export default function StartupCards() {
  return (
    <Container maxW="container.lg">
      {/* Startups in Innovators Spotlight */}

      {/* Startups in Green Pop-up Village */}
      <Box>
        <Heading
          my={20}
          fontWeight="700"
          fontSize={{ xs: '26px', md: '28px' }}
          lineHeight="130%"
          color="#197542"
          textAlign="left"
          mb="2rem"
          borderLeft="3px solid #197542"
          pl="10px"
        >
          Startups in Green Pop-up Village
        </Heading>
        <Grid templateColumns="repeat(auto-fit, minmax(200px, 1fr))" gap={6}>
          {greenPopupVillage.map((startup, index) => (
            <Link href={startup?.website || ''}>
              <Box
                key={index}
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                p={4}
                textAlign="center"
                h="180px"
                boxShadow="4px 4px 4px 0px #98CAA7"
              >
                <VStack spacing={1}>
                  <Image
                    src={startup.logo}
                    alt={`${startup.name} logo`}
                    boxSize="100px"
                    objectFit="contain"
                    mx="auto"
                  />
                  <Text fontSize="16px" fontWeight="semibold" color="#010E04">
                    {startup.name}
                  </Text>
                </VStack>
              </Box>
            </Link>
          ))}
        </Grid>
      </Box>

      <Box mb={12}>
        <Heading
          my={20}
          fontWeight="700"
          fontSize={{ xs: '26px', md: '28px' }}
          lineHeight="130%"
          color="#197542"
          textAlign="left"
          mb="2rem"
          borderLeft="3px solid #197542"
          pl="10px"
        >
          Startups in Innovators Spotlight
        </Heading>
        <Grid templateColumns="repeat(auto-fit, minmax(200px, 1fr))" gap={6}>
          {innovatorsSpotlight.map((startup, index) => (
            <Box
              key={index}
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
              h="180px"
              p={4}
              textAlign="center"
              boxShadow="4px 4px 4px 0px #98CAA7"
            >
              <VStack spacing={4}>
                <Image
                  src={startup.logo}
                  alt={`${startup.name} logo`}
                  boxSize="100px"
                  objectFit="contain"
                  mx="auto"
                />
                <Text fontSize="16px" fontWeight="semibold" color="#010E04">
                  {startup.name}
                </Text>
              </VStack>
            </Box>
          ))}
        </Grid>
      </Box>
    </Container>
  );
}
